class ConferenceDetailsController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        // Initialize ajax/api controls
        this.data = {};
        this.spinner = true;
        this.httpError = false;

        // Initialize models for filter and radio button controls
        this.radioModel = {};
        this.filterModel = {};
        this.dayTime = {};

        // Initialize arrays to manage valid sessions
        this.validSessions = [];
        this.validSessionsPerCat = [];

        // Initialize no results toggle
        this.noResults = false;

        // Initialize edit message toggle
        this.msgToggle = false;

        // Intialize pagination per day functionality
        this.selected = 0;

        // Initialize character limit bool
        this.charLimit = true;
    }

    $onInit() {
        if(typeof this.onLoad !== 'undefined' && this.onLoad !== null) {
            if(this.onLoad === 'true') {
                this.loadSchedule();
            }
        }
    }

    loadSchedule() {
        this.spinner = true;
        this.$timeout(() => {
            this.$http({
                url: '/api/conference/conferencesessions?id=' + this.conferenceId + '&cpid=' + this.conferencePackageId,
                method: 'GET'
            }).then((response) => {
                this.data = response.data;
                // Initialize model to manage radio button binding and session highlighting
                this.setRadioBindings();
                // Initialize model that defines the filters and filter categories returned from the API
                for (var filter in this.data.ConferenceTagGroups) {
                    this.filterModel[filter] = {};
                    this.filterModel[filter].active = false;
                    this.filterModel[filter].name = this.data.ConferenceTagGroups[filter].GroupName;
                    this.filterModel[filter].items = {};
                    for (var filterItem in this.data.ConferenceTagGroups[filter].Tags) {
                        this.filterModel[filter].items[filterItem] = {};
                        this.filterModel[filter].items[filterItem].value = false;
                        this.filterModel[filter].items[filterItem].valueString = this.data.ConferenceTagGroups[filter].Tags[filterItem];
                    }
                }
                this.spinner = false;
                // Initialize filters to display items on page load
                this.setFilters();
                if(typeof (this.$window.isacaDp.feature.conferenceTabs) !== 'undefined') {
                    this.$window.isacaDp.feature.conferenceTabs.loadSessionsCallback();
                }
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }

    setFilters() {
        this.noResults = true;
        // Clear all existing filters and/or valid sessions to get ready for filter handling
        this.clearCategories();
        this.validSessionsPerCat = [];
        // Loop through filter categores
        for (var category in this.filterModel) {
            // Then loop through individual filters in that category
            for (var item in this.filterModel[category].items) {
                // If any filter in that category is active...
                if(this.filterModel[category].items[item].value) {
                    if(!this.filterModel[category].active) {
                        // Then set it's filter category to active
                        this.filterModel[category].active = true;
                    }
                }
            }
        }
        // Ooohwee, here we go...
        // Loop through the days of each conference
        for (var day in this.data.ConferenceDays) {
            // Then loop through the timeslots of each day
            for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                // Then loop through each session of each day
                for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                    //  Then loop through each filter category
                    for (var filterCat in this.filterModel) {
                        // If that filter category is set to active
                        if(this.filterModel[filterCat].active) {
                            // Then we filter through each filter of that category
                            for (var filterItem in this.filterModel[filterCat].items) {
                                // If that filter is set to active
                                if(this.filterModel[filterCat].items[filterItem].value) {
                                    // Loop through each filter tag in this session
                                    for (var tag in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags) {
                                        // If the filter tag name in this session matches the active filter category
                                        if(this.filterModel[filterCat].name === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags[tag].TagName) {
                                            // And if the filter tag value matches this session's filter tag value
                                            if(this.filterModel[filterCat].items[filterItem].valueString === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags[tag].TagValue) {
                                                // Then we add an array to our valid sessions array and add the value to our new array
                                                if(typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                                    this.validSessionsPerCat[filterCat] = [];
                                                }
                                                this.validSessionsPerCat[filterCat].push(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId);
                                            } else {
                                                // Otherwise we create the array anyway in the case no values match
                                                if(typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                                    this.validSessionsPerCat[filterCat] = [];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            // If the filter isn't set to active, we add all sessions to this category's array because they are all valid
                            if(typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                this.validSessionsPerCat[filterCat] = [];
                            }
                            this.validSessionsPerCat[filterCat].push(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId);
                        }
                    }
                }
            }
        }
        // This is magically crossreferencing our array of arrays (all valid sessions in each filter category)
        // This will return one array of each session that appears in each filter category array
        var arrays = this.validSessionsPerCat;
        this.validSessions = arrays.shift().reduce(function(res, v) {
            if(res.indexOf(v) === -1 && arrays.every(function(a) {
                return a.indexOf(v) !== -1;
            })) res.push(v);
            return res;
        }, []);
        // Initialize model that keeps track of valid timeslot and days while filtering
        this.setDayTimeBindings();
    }

    filter() {
        return (item) => {
            // Use default Angular filtering to loop each valid session in our array of valid sessions, then return only items that match a ProductId with that array
            for (var id in this.validSessions) {
                if(this.validSessions[id] === item.ProductId) {
                    return item;
                }
            }
        };
    }

    toggleSpinnerOverlay(id) {
        $(id).overlay();
    }

    cancelUpdate() {
        this.msgToggle = false;
        // Reset all values in the binded radio button model
        // This will reset all radio buttons and session highlighting
        this.setRadioBindings();
    }

    toggleDay(key) {
        // Toggle day pagination when user clicks on day they wish to view.
        // Mobile has an entirely different view which this condition controls
        if(this.$window.innerWidth < 1024 || this.$window.innerHeight < 700) {
            if(this.selected !== key) {
                this.selected = key;
            } else {
                this.selected = '';
            }
        } else {
            this.selected = key;
        }
    }

    toggleRadio($event, page, timeslot, id) {
        $event.preventDefault();
        $event.stopPropagation();
        this.msgToggle = true;
        if(this.radioModel[page][timeslot].value === id) {
            this.radioModel[page][timeslot].value = '';
        } else {
            this.radioModel[page][timeslot].value = id;
        }
    }

    toggleCharLimit(session) {
        // Simply toggling to show the full description in corresponding session
        session.toggle = !session.toggle;
    }

    clearAll() {
        // We're clearing filters so we might as well deactivate the filter categories also
        this.clearCategories();
        // Loop through each category filter
        for (var category in this.filterModel) {
            // Then loop through individual filter of each category
            for (var filter in this.filterModel[category].items) {
                // Then deactive that filter
                this.filterModel[category].items[filter].value = false;
            }
        }
        // Reset filters so that users don't have to hit the Apply button
        this.setFilters();
    }

    clearCategories() {
        // Deactivating each filter category
        for (var category in this.filterModel) {
            this.filterModel[category].active = false;
        }
    }

    setRadioBindings() {
        // Build model to manage radio button binding and session highlighting
        for (var day in this.data.ConferenceDays) {
            this.radioModel[day] = {};
            for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                this.radioModel[day][timeslot] = {};
                this.radioModel[day][timeslot].value = '';
                for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                    if(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsRegistered) {
                        this.radioModel[day][timeslot].value = this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId;
                    }
                }
            }
        }
    }

    setDayTimeBindings() {
        // Check if this is View Itinerary
        if(this.userStatus !== 'anonymous' && this.isRegistered && this.mode !== 'edit') {
            // If it is, valid day/time bindings based off of each session's IsRegistered Field
            for (var day in this.data.ConferenceDays) {
                this.dayTime[day] = {};
                this.dayTime[day].valid = false;
                this.dayTime[day].items = {};
                for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    this.dayTime[day].items[timeslot] = {};
                    this.dayTime[day].items[timeslot].valid = false;
                    this.dayTime[day].items[timeslot].hidden = true;
                    for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                        if(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsRegistered || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId === '') {
                            // Then this day becomes valid
                            if(!this.dayTime[day].valid) {
                                this.dayTime[day].valid = true;
                            }
                            // and this timeslot becomes valid
                            if(!this.dayTime[day].items[timeslot].valid) {
                                if(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Registration') {
                                    this.dayTime[day].items[timeslot].hidden = false;
                                }
                                this.dayTime[day].items[timeslot].valid = true;
                            }
                        }
                    }
                }
            }
        } else if(this.review) {
            for (day in this.data.ConferenceDays) {
                this.dayTime[day] = {};
                this.dayTime[day].valid = false;
                this.dayTime[day].items = {};
                for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    this.dayTime[day].items[timeslot] = {};
                    this.dayTime[day].items[timeslot].valid = false;
                    this.dayTime[day].items[timeslot].hidden = true;
                    for (session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                        if(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsSelected || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType === 'Registration' || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType === 'Break') {
                            // Then this day becomes valid
                            if(!this.dayTime[day].valid) {
                                this.dayTime[day].valid = true;
                            }
                            // and this timeslot becomes valid
                            if(!this.dayTime[day].items[timeslot].valid) {
                                this.dayTime[day].items[timeslot].valid = true;
                            }
                        }
                    }
                }
            }
        } else {
            for (day in this.data.ConferenceDays) {
                this.dayTime[day] = {};
                this.dayTime[day].valid = false;
                this.dayTime[day].items = {};
                for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    this.dayTime[day].items[timeslot] = {};
                    this.dayTime[day].items[timeslot].valid = false;
                    this.dayTime[day].items[timeslot].hidden = true;
                }
            }
            // Loop through each day
            for (day in this.data.ConferenceDays) {
                // Then loop through each timeslot
                for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    // The loop through each sessions
                    for (session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                        // In each session loop through each valid session
                        for (var validSession in this.validSessions) {
                            // If the one of the valid sessions in this day.timeslot is valid
                            if(this.validSessions[validSession] === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId) {
                                // Then this day becomes valid
                                if(!this.dayTime[day].valid) {
                                    this.dayTime[day].valid = true;
                                }
                                // and this timeslot becomes valid
                                if(!this.dayTime[day].items[timeslot].valid) {
                                    if(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Registration' && this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Break') {
                                        this.dayTime[day].items[timeslot].hidden = false;
                                    }
                                    this.dayTime[day].items[timeslot].valid = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        // Check if there are any results
        for (day in this.dayTime) {
            if(this.dayTime[day].valid) {
                this.selected = parseInt(day);
                this.noResults = false;
                break;
            }
        }
    }
}

export default ConferenceDetailsController;



// WEBPACK FOOTER //
// ./src/app/angular/conference-details/conference-details.controller.js